module.exports = __webpack_public_path__ + "alignment-bad.5ebcc7530684bcd11d8f681eb1cf82c4.hashedasset.png";